import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import FincludeLogo from "../../assets/images/finclude.png";
import { Link } from "react-router-dom";
import ReactCodeInput from "react-code-input";
import { useMutation } from "react-query";
import {
  activateAccount,
  passwordResetValidation,
} from "../../queries/session";
import { parse } from "query-string";

const ValidatePage = ({ history, toast }) => {
  const [codeError, setCodeError] = useState("");
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true);
  const [otpCode, setOptCode] = useState("");
  const [jwt, setJwt] = useState(null);
  const [path, setPath] = useState(null);

  useEffect(() => {
    setPath(location.pathname);
    setJwt(parse(location.search).token);
  }, []);

  const handleCodeInputChange = (value) => {
    setOptCode(value);
    if (value.length === 6) {
      setSubmitButtonDisabled(false);
    }
  };

  const activeAccount = useMutation((otpCode) => {
    return activateAccount(otpCode, jwt)
      .then(() => {
        toast.success("Your account activated successfully!");
        history.push("/login");
      })
      .catch(() => {
        setCodeError("Code is not Valid");
      });
  });

  const validatePasswordReset = useMutation((otpCode) => {
    return passwordResetValidation(otpCode, jwt)
      .then(() => {
        toast.success("Your password is reset successfully!");
        history.push("/login");
      })
      .catch(() => {
        setCodeError("Code is not Valid");
      });
  });

  return (
    <div className="fs-wrap fs-form">
      <form className="box mw-400 p-sm-5">
        <img
          className="d-block mx-auto mb-4"
          src={FincludeLogo}
          alt="Finclude"
        />
        <h5 className="text-center mb-3">
          Verification code required to continue
        </h5>
        <p className="text-center">
          An email with a verification code has been sent to you.
        </p>
        <p className="text-center text-small">Enter the code below</p>
        <ReactCodeInput
          type="number"
          fields={6}
          onChange={(value) => {
            handleCodeInputChange(value);
          }}
        />
        {path === "/account-activation" ? (
          <a
            className="btn btn-main d-block w-100 mt-3"
            onClick={() => activeAccount.mutate(otpCode)}
            disabled={submitButtonDisabled}
          >
            Continue
          </a>
        ) : (
          <a
            className="btn btn-main d-block w-100 mt-3"
            onClick={() => validatePasswordReset.mutate(otpCode)}
            disabled={submitButtonDisabled}
          >
            Continue
          </a>
        )}

        {codeError && (
          <>
            <hr className="my-4" />
            <div className="text-center">
              <p className="text-small text-error mb-2">{codeError}</p>
              <button href="#" className="btn btn-sm btn-main btn-round">
                Send new code
              </button>
            </div>
            <hr className="my-4" />
          </>
        )}

        <p className="text-small text-center mt-45">
          Remembered your password?{" "}
          <Link className="d-inline-block link-color" to="/login">
            Login
          </Link>
        </p>

        <p className="text-small text-center">
          Wrong email address? Back to{" "}
          <Link className="d-inline-block link-color" to="/sign-up">
            Sign up
          </Link>
        </p>
      </form>
    </div>
  );
};

ValidatePage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default ValidatePage;
